import Api from '@/services/Api'

export default {
  getList () {
    return Api().get('/email/')
  },

  // Get
  getMailbox (mail) {
    return Api().get('/email/mailbox/' + mail)
  },
  getForward (mail) {
    return Api().get('/email/forward/' + mail)
  },

  // Delete
  deleteMailbox (mail) {
    return Api().delete('/email/mailbox/' + mail)
  },
  deleteForward (mail) {
    return Api().delete('/email/forward/' + mail)
  },

  // Create
  createMailbox (data, password, sendConfig) {
    return Api().post('/email/mailbox/', {...data, password: password, configemail: sendConfig.email, configphone: sendConfig.phone})
  },
  createForward (data) {
    return Api().post('/email/forward/', data)
  },

  // Update
  updateMailbox (mail, data, password, sendConfig) {
    return Api().put('/email/mailbox/' + mail, {...data, password: password, configemail: sendConfig.email, configphone: sendConfig.phone})
  },
  updateForward (mail, data) {
    return Api().put('/email/forward/' + mail, data)
  }
}
